import { jsx as o } from "react/jsx-runtime";
import e from "classnames";
import n from "./index.es741.js";
const i = "spinner-component", p = ({ variant: t = "brand", testId: r = i }) => {
  const s = e(n.icon, [n[`${t}`]]);
  return /* @__PURE__ */ o(
    "svg",
    {
      "data-testid": r,
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      className: s,
      "data-pl-variant": t,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M18 9.5a9 9 0 0 0-9-9v1.35a7.65 7.65 0 0 1 7.65 7.65H18Z"
        }
      )
    }
  );
};
export {
  i as SPINNER_DEFAULT_TESTID,
  p as Spinner
};
//# sourceMappingURL=index.es64.js.map
